import { IOrderbook, ITickerSocket, TradeSocket } from 'types/cex/spot';
import { IChartTimeframe, KLine } from 'types/charts';

import { BaseStrategy, IInitArgs } from '../base_strategy';

type FetchKlinesReq = {
  base: string;
  quote: string;
  from: number;
  to: number;
  limit: number;
  interval: IChartTimeframe;
};

export class IndodaxStrategy implements BaseStrategy {
  ws: undefined;
  pair: string;
  base: string;
  depth: number;

  onOrderbookUpdate: (v: IOrderbook) => void;
  onTickerUpdate: (v: ITickerSocket) => void;
  klineUpdate: (v: KLine) => void;
  precisionUpdate: (v: number) => void;
  onTradeUpdate: (v: TradeSocket) => void;

  constructor({
    base,
    quote,
    orderbookDepth,
    onOrderbookUpdate,
    onTickerUpdate,
    klineUpdate,
    precisionUpdate,
    onTradeUpdate,
  }: IInitArgs) {
    this.pair = `${base.toUpperCase()}${quote.toUpperCase()}`;
    this.base = base.toUpperCase();
    this.depth = orderbookDepth ?? 20;

    this.onOrderbookUpdate = onOrderbookUpdate;
    this.onTickerUpdate = onTickerUpdate;
    this.klineUpdate = klineUpdate;
    this.precisionUpdate = precisionUpdate;
    this.onTradeUpdate = onTradeUpdate;
  }

  setOrderbookDepth(depth: number) {
    this.depth = depth;
  }

  fetchKlines = async (_req: FetchKlinesReq): Promise<KLine[]> => {
    return [] as unknown as Promise<KLine[]>;
  };

  fetchTickerPrecision = async () => {
    let precision = 1;

    if (this.base === 'ISLM') {
      precision = 5;
    }

    this.precisionUpdate(precision);
  };

  fetchOrderbook = async () => undefined;

  fetchKline = async () => [];

  fetchTrades = async () => [];

  connectWebSocket = async () => {};

  closeWebSocket = async () => {};

  switchOrderbookTick = () => {};

  getOrderbookTicks = () => [];

  fetch = async () => await this.fetchTickerPrecision();

  static init = async (args: IInitArgs) => {
    const instance = new IndodaxStrategy(args);

    await instance.fetch();

    return instance;
  };
}
